import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ICustomerServiceItem } from "../../utils/types/models";

export default createEntityReducer<ICustomerServiceItem>(Endpoint.CustomerServices);
